<mat-toolbar #menuItemsContainer liSizeChange (sizeChange)="onSizeChange()" id="menu-toolbar" class="top-navbar mat-elevation-z2" fxLayoutAlign="center center">
    <!-- <a mat-button routerLink="/" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">{{ 'NAV.HOME' | translate }}</a> -->
</mat-toolbar>
